/* eslint-disable eqeqeq */
import Swal from 'sweetalert2';
import {
    ADMIN_UI_URL, AIS_UI_URL, APGLI_UI_URL, APZPF_UI_URL, BUDGET_PLANNING_UI_URL,
    BUDGET_UI_URL, CASHLESS_PAYMENTS_URL, CONTRACT_UI_URL, CORPORATION_UI_URL, DASHBOARD_UI_URL, DCM_UI_URL,
    ESR_UI_URL, ESS_UI_URL, EVIGIL_UI_URL, EXPENDITURE_UI_URL, GAD_UI_URL, GCINFO_UI_URL, GOIR_UI_URL,
    GPS_UI_URL, HRMS_UI_URL, HR_ACTION_UI_URL, LOGIN_DOMAIN, PAYROLL_NIDHI_UI_URL,
    PAYROLL_UI_URL, PENSIONS_UI_URL, PFMS_UI_URL, SRTS_UI_URL, WORKS_UI_URL, MR_UI_URL,
    PO2025_UI_URL,
    ESS_DOMAIN, HCM_UI_URL
} from '../Api/APIURLS';
import { Popover } from 'react-bootstrap';

var createGuest = require('cross-domain-storage/guest');
export function allowNumbersOnly(e) {
    var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
    var value = Number(e.target.value + e.key) || 0;
    if (keyCode >= 48 && keyCode <= 57) {
        return isValidNumber(value);
    }
    else {
        e.preventDefault();
    }
    return false
}
export function isValidNumber(number) {
    return (1 <= number && number <= 10)
}
export function allowOnlyNumber(e) {
    const allowedKeys = [46, 8, 9, 27, 13, 110];

    if (
        allowedKeys.includes(e.keyCode) ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
        const value = Number(e.target.value + e.key) || 0;
        return isValidNumber(value);
    }

    // Ensure that it is a number and stop the keypress
    if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)
    ) {
        e.preventDefault();
    }
}

export function ClearLocalStorage() {
    let mainAppguest = createGuest(LOGIN_DOMAIN);
    localStorage.removeItem("token");
    localStorage.removeItem("serviceList");
    localStorage.clear();
    mainAppguest.remove('token', function (error, data) {
        // foo is now removed
    });
    mainAppguest.remove('userData', function (error, data) {
        // foo is now removed
    });
    mainAppguest.remove('serviceList', function (error, data) {
        // foo is now removed
    });
    mainAppguest.remove('userName', function (error, data) {
        // foo is now removed
    });
    mainAppguest.remove('refresh_token', function (error, data) {
        // foo is now set to 'bar'  
    });
    mainAppguest.remove('userId', function (error, data) {
        // foo is now set to 'bar'  
    });
    mainAppguest.close()
}
export function redirectUrl(url, module) {
    window.parent.location.href = url
}
export const GOS_PDF_URL = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/Downloads/'

export const GOS_PDF_URL2 = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/'

export const GOS_PDF_URL3 = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/'

export const GOS_BUDGET_URL_UPDATED = 'https://s3://public-resources-nidhi-dev/budget-files/'

export const GOS_PDF_BUDGET_URL = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/budget-files/'
export const memovehicle = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/vehicle/'
export const UserManualforGovtVehicles = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/vehicle/'
export const UserManualforHiredVehicles = 'https://s3.ap-south-1.amazonaws.com/images.herb.apcfss.in/vehicle/'
export const UserManualsforHrPayroll = 'https://s3://public-resources-nidhi-dev/payroll/'
export const UserManualsforGPF = 'https://s3://public-resources-nidhi-dev/gpf/'
export const UserManualsforPension = 'https://s3://public-resources-nidhi-dev/pension/'
export const UserManualsforHrms = 'https://s3://public-resources-nidhi-dev/hrms/'
export const UserManualsforVehicles = 'https://s3://public-resources-nidhi-dev/vehicle/'


export const origins =
    [
        APZPF_UI_URL, AIS_UI_URL, APGLI_UI_URL,
        BUDGET_UI_URL, BUDGET_PLANNING_UI_URL,
        CORPORATION_UI_URL, CONTRACT_UI_URL,
        DASHBOARD_UI_URL, DCM_UI_URL,
        EXPENDITURE_UI_URL, ESS_UI_URL, ESR_UI_URL,
        GPS_UI_URL, GCINFO_UI_URL, GOIR_UI_URL,
        HRMS_UI_URL, HR_ACTION_UI_URL,
        LOGIN_DOMAIN,
        PAYROLL_NIDHI_UI_URL, PENSIONS_UI_URL, PAYROLL_UI_URL, PFMS_UI_URL,
        SRTS_UI_URL,
        WORKS_UI_URL, ADMIN_UI_URL, GAD_UI_URL, EVIGIL_UI_URL,
        CASHLESS_PAYMENTS_URL, MR_UI_URL, PO2025_UI_URL, ESS_DOMAIN, HCM_UI_URL
    ];

export const SetServicesListInMainAppGuest = async (servicesList) => {
    let mainAppguest = createGuest(LOGIN_DOMAIN);
    await mainAppguest.set('servicesListMasterData', JSON.stringify(servicesList), function (error, data) {
        // set data
    });
};

export const accordionItems = [
    {
        header: "Unified Pension Scheme - Furnishing data in prescribed Formats",
        links: [
            {
                text: "Govt. Memo No.2839648/A1/SC.A/2025 of General Administration Department, dt.23.05.2025.",
                url: `${GOS_PDF_URL}Memo_No_2839648_Dated_23_05_2025_PFRDA_Timely_implementation_of_UPS_for_AIS_officers.pdf`,
                downloadUrl: "Downloads/Memo_No_2839648_Dated_23_05_2025_PFRDA_Timely_implementation_of_UPS_for_AIS_officers.pdf"
            },
            {
                text: "Govt. Circular No.2836695/A1/2025, dt.16.06.2025 of General Administration Department.",
                url: `${GOS_PDF_URL}Memo_No_2836695A12025_dt_16_06_2025_of_General_Administration_Department.pdf`,
                downloadUrl: "Downloads/Memo_No_2836695A12025_dt_16_06_2025_of_General_Administration_Department.pdf"
            },
            {
                text: "PAO Office circular, dt.05.06.2025.",
                url: `${GOS_PDF_URL}LETTER_ON_UPS_AND_NPS_PROFORMA_TO_THE_ALL_AIS_OFFICERS.pdf`,
                downloadUrl: "Downloads/LETTER_ON_UPS_AND_NPS_PROFORMA_TO_THE_ALL_AIS_OFFICERS.pdf"
            },
            {
                text: "PAO Office reminder letter No.08.07.2025.",
                url: `${GOS_PDF_URL}UPS_REMINDER.pdf`,
                downloadUrl: "Downloads/UPS_REMINDER.pdf"
            }
        ],
        image: true
    },
    {
        header: "Chief Minister’s Relief Fund",
        links: [
            {
                text: "G.O.MS.No. 91",
                url: `${GOS_PDF_URL2}2024FIN_APCM_ReliefFund.pdf`,
                downloadUrl: "2024FIN_APCM_ReliefFund.pdf"
            }
        ],
        image: false
    },
    {
        header: "User Manual for Procurement of Consulting Agencies / Individual Consultants",
        links: [
            {
                text: "User Manual for Procurement of Consulting Agencies / Individual Consultants",
                url: `${GOS_PDF_URL2}User_Manual_for_PCS_L_1.pdf`,
                downloadUrl: "User_Manual_for_PCS_L_1.pdf"
            }
        ],
        image: false
    },

    {
        header: "Vehicle Sanctions ( legacy data capture) memo",
        links: [
            {
                text: "Memo Vehicle",
                url: `${memovehicle}memo-vehicle.pdf`,
                downloadUrl: "vehicle/memo-vehicle.pdf"
            },
            {
                text: "User Manual for Government Vehicles",
                url: `${UserManualforGovtVehicles}User_Manual_for_Govt_Vehicles.pdf`,
                downloadUrl: "vehicle/User_Manual_for_Govt_Vehicles.pdf"
            },
            {
                text: "User Manual for Hired Vehicles",
                url: `${UserManualforHiredVehicles}User_Manual_for_Hired_Vehicle's.pdf`,
                downloadUrl: "vehicle/User_Manual_for_Hired_Vehicle's.pdf"
            },
        ],
        image: false
    },
    {
        header: "Pensions",
        links: [
            {
                text: "G.O.MS.NO.221",
                url: `${GOS_PDF_URL}2016FIN_MS221_220821_104336.pdf`,
                downloadUrl: "Downloads/2016FIN_MS221_220821_104336.pdf"
            },
            {
                text: "GO MS NO.97",
                url: `${GOS_PDF_URL}07052014FIN_MS97.PDF`,
                downloadUrl: "Downloads/07052014FIN_MS97.PDF"
            },
            {
                text: "G.O.MS.NO.100",
                url: `${GOS_PDF_URL}Payment_of_retirement_benefits_on_the_day_of_retirement.PDF`,
                downloadUrl: "Downloads/Payment_of_retirement_benefits_on_the_day_of_retirement.PDF"
            }
        ],
        image: false
    },
    {
        header: "PRC",
        links: [
            {
                text: "G.O.MS.NO.8",
                url: `${GOS_PDF_URL}5DAs.pdf`,
                downloadUrl: "Downloads/5DAs.pdf"
            },
            {
                text: "G.O.MS.NO.30",
                url: `${GOS_PDF_URL}AQP.pdf`,
                downloadUrl: "Downloads/AQP.pdf"
            },
            {
                text: "G.O.MS.NO.29",
                url: `${GOS_PDF_URL}CCA.pdf`,
                downloadUrl: "Downloads/CCA.pdf"
            },
            {
                text: "G.O.MS.NO.09",
                url: `${GOS_PDF_URL}DR20220117_20552916.pdf`,
                downloadUrl: "Downloads/DR20220117_20552916.pdf"
            },
            {
                text: "G.O.MS.NO.105",
                url: `${GOS_PDF_URL}Funeral_Charges.pdf`,
                downloadUrl: "Downloads/Funeral_Charges.pdf"
            },
            {
                text: "G.O.MS.NO.106",
                url: `${GOS_PDF_URL}G.O_No._106..pdf`,
                downloadUrl: "Downloads/G.O_No._106..pdf"
            },
            {
                text: "G.O.MS.NO.18",
                url: `${GOS_PDF_URL}GO_18.pdf`,
                downloadUrl: "Downloads/GO_18.pdf"
            },
            {
                text: "G.O.MS.NO.27",
                url: `${GOS_PDF_URL}GO_MS_NO_27_HRA.pdf`,
                downloadUrl: "Downloads/GO_MS_NO_27_HRA.pdf"
            },
            {
                text: "G.O.MS.NO.28",
                url: `${GOS_PDF_URL}GO_MS_NO_28_HRA.pdf`,
                downloadUrl: "Downloads/GO_MS_NO_28_HRA.pdf"
            },
            {
                text: "G.O.MS.NO.100",
                url: `${GOS_PDF_URL}GO_Ms_No_100.pdf`,
                downloadUrl: "Downloads/GO_Ms_No_100.pdf"
            },
            {
                text: "G.O.MS.NO.102",
                url: `${GOS_PDF_URL}GO_Ms_No_102.pdf`,
                downloadUrl: "Downloads/GO_Ms_No_102.pdf"
            },
            {
                text: "G.O.MS.NO.103",
                url: `${GOS_PDF_URL}GO_Ms_No_103.pdf`,
                downloadUrl: "Downloads/GO_Ms_No_103.pdf"
            },
            {
                text: "G.O.MS.NO.104",
                url: `${GOS_PDF_URL}GO_MS_NO_104.pdf`,
                downloadUrl: "Downloads/GO_MS_NO_104.pdf"
            },
            {
                text: "G.O.MS.NO.15",
                url: `${GOS_PDF_URL}GOMS15Superannuationageenhanceto62years.pdf`,
                downloadUrl: "Downloads/GOMS15Superannuationageenhanceto62years.pdf"
            },
            {
                text: "G.O.MS.NO.192",
                url: `${GOS_PDF_URL}Medical_Reimbursement_extension.pdf`,
                downloadUrl: "Downloads/Medical_Reimbursement_extension.pdf"
            },
            {
                text: "G.O.MS.NO.5",
                url: `${GOS_PDF_URL}MTS_TO_CONTRACT.pdf`,
                downloadUrl: "Downloads/MTS_TO_CONTRACT.pdf"
            },
            {
                text: "G.O.MS.NO.6",
                url: `${GOS_PDF_URL}MTS_TO_NMRS.pdf`,
                downloadUrl: "Downloads/MTS_TO_NMRS.pdf"
            },
            {
                text: "G.O.MS.NO.7",
                url: `${GOS_PDF_URL}outsourcing.pdf`,
                downloadUrl: "Downloads/outsourcing.pdf"
            },
            {
                text: "G.O.MS.NO.02",
                url: `${GOS_PDF_URL}PENSION.pdf`,
                downloadUrl: "Downloads/PENSION.pdf"
            },
            {
                text: "G.O.MS.NO.101",
                url: `${GOS_PDF_URL}PRC_2022_Allowances_101.pdf`,
                downloadUrl: "Downloads/PRC_2022_Allowances_101.pdf"
            },
            {
                text: "G.O.MS.NO.1",
                url: `${GOS_PDF_URL}RPS_2022.pdf`,
                downloadUrl: "Downloads/RPS_2022.pdf"
            }
        ],
        image: false
    },
    {
        header: "RTC",
        links: [
            {
                text: "ACT NO 36",
                url: `${GOS_PDF_URL}ACT_NO_36.pdf`,
                downloadUrl: "Downloads/ACT_NO_36.pdf"
            },
            {
                text: "G.O.MS.No. 50",
                url: `${GOS_PDF_URL}GO_50.PDF`,
                downloadUrl: "Downloads/GO_50.PDF"
            },
            {
                text: "G.O.MS.No. 51",
                url: `${GOS_PDF_URL}GO_51.PDF`,
                downloadUrl: "Downloads/GO_51.PDF"
            },
            {
                text: "G.O.MS.No. 52",
                url: `${GOS_PDF_URL}GO_52.PDF`,
                downloadUrl: "Downloads/GO_52.PDF"
            },
            {
                text: "G.O.MS.No.2",
                url: `${GOS_PDF_URL}GO2_OF_GAD_CABINET.pdf`,
                downloadUrl: "Downloads/GO2_OF_GAD_CABINET.pdf"
            },
            {
                text: "MEMO ON RTC PF ELEMENTS",
                url: `${GOS_PDF_URL}MEMO_ON_RTC_PF_ELEMENTS.pdf`,
                downloadUrl: "Downloads/MEMO_ON_RTC_PF_ELEMENTS.pdf"
            },
            {
                text: "G.O.MS.No. 113",
                url: `${GOS_PDF_URL}prc_go_113.pdf`,
                downloadUrl: "Downloads/prc_go_113.pdf"
            },
            {
                text: "G.O.MS.No. 114",
                url: `${GOS_PDF_URL}prc_go_114.pdf`,
                downloadUrl: "Downloads/prc_go_114.pdf"
            }
        ],
        image: false
    },
    {
        header: "PD ACCOUNTS",
        links: [
            {
                text: "G.O. Ms. No.: 99",
                url: `${GOS_PDF_URL}99_PD_ACCOUNTS.pdf`,
                downloadUrl: "Downloads/99_PD_ACCOUNTS.pdf"
            },
            {
                text: "G.O.MS.No.145",
                url: `${GOS_PDF_URL}145_PD_ACCOUNTS.PDF`,
                downloadUrl: "Downloads/145_PD_ACCOUNTS.PDF"
            },
            {
                text: "G.O.Ms.No.125",
                url: `${GOS_PDF_URL}GO_125_PDAs5_14.pdf`,
                downloadUrl: "Downloads/GO_125_PDAs5_14.pdf"
            },
            {
                text: "G.O.MS.No. 165",
                url: `${GOS_PDF_URL}GO_165_PDAs9_17.PDF`,
                downloadUrl: "Downloads/GO_165_PDAs9_17.PDF"
            },
            {
                text: "G.O.MS.No. 20",
                url: `${GOS_PDF_URL}GO20PDAs_3_20.PDF`,
                downloadUrl: "Downloads/GO20PDAs_3_20.PDF"
            },
            {
                text: "CIRCULAR MEMO No.15036-B/485/BG/A1/2000",
                url: `${GOS_PDF_URL}GOMSNO43.pdf`,
                downloadUrl: "Downloads/GOMSNO43.pdf"
            }
        ],
        image: false
    },
    {
        header: "GIS",
        links: [
            {
                text: "G.O.MS.No. 13",
                url: `${GOS_PDF_URL}2017_GIS_MS13.PDF`,
                downloadUrl: "Downloads/2017_GIS_MS13.PDF"
            },
            {
                text: "G.O.MS.No. 3",
                url: `${GOS_PDF_URL}2018_GIS_MS3.PDF`,
                downloadUrl: "Downloads/2018_GIS_MS3.PDF"
            },
            {
                text: "G.O.MS.No. 51",
                url: `${GOS_PDF_URL}2018FIN_MS51.PDF`,
                downloadUrl: "Downloads/2018FIN_MS51.PDF"
            },
            {
                text: "G.O.MS.No. 19",
                url: `${GOS_PDF_URL}2019FIN_MS19.PDF`,
                downloadUrl: "Downloads/2019FIN_MS19.PDF"
            },
            {
                text: "G.O.MS.No. 131",
                url: `${GOS_PDF_URL}2019FIN_MS131.PDF`,
                downloadUrl: "Downloads/2019FIN_MS131.PDF"
            },
            {
                text: "G.O.MS.No. 41",
                url: `${GOS_PDF_URL}2020FIN_MS41.PDF`,
                downloadUrl: "Downloads/2020FIN_MS41.PDF"
            },
            {
                text: "G.O.MS.No. 122",
                url: `${GOS_PDF_URL}GIS_122.pdf`,
                downloadUrl: "Downloads/GIS_122.pdf"
            },
            {
                text: "G.O.MS.No. 177",
                url: `${GOS_PDF_URL}GIS_calculation_upto_07_2022.pdf`,
                downloadUrl: "Downloads/GIS_calculation_upto_07_2022.pdf"
            },
            {
                text: "G.O.MS.No. 111",
                url: `${GOS_PDF_URL}GIS_Go_No_111.PDF`,
                downloadUrl: "Downloads/GIS_Go_No_111.PDF"
            },
            {
                text: "G.O.MS.No. 156",
                url: `${GOS_PDF_URL}GIS_MS156.PDF`,
                downloadUrl: "Downloads/GIS_MS156.PDF"
            },
            {
                text: "G.O.MS.No. 177",
                url: `${GOS_PDF_URL}GO_MS_177.pdf`,
                downloadUrl: "Downloads/GO_MS_177.pdf"
            },
            {
                text: "G.O.MS.No.2",
                url: `${GOS_PDF_URL}Go_Ms_No_2.pdf`,
                downloadUrl: "Downloads/Go_Ms_No_2.pdf"
            },
            {
                text: "G.O.Ms.No.81",
                url: `${GOS_PDF_URL}GO_MS81.PDF`,
                downloadUrl: "Downloads/GO_MS81.PDF"
            }
        ],
        image: false
    },
    {
        header: "Districts Reorganization",
        links: [
            {
                text: "G.O.Ms.No.31",
                url: `${GOS_PDF_URL}GO_MS_31_Districts_Restructuring_Procedural_Guidelines.pdf`,
                downloadUrl: "Downloads/GO_MS_31_Districts_Restructuring_Procedural_Guidelines.pdf"
            },
            {
                text: "G.O.Ms.No.51",
                url: `${GOS_PDF_URL}GOMs_51_Agriculture.pdf`,
                downloadUrl: "Downloads/GOMs_51_Agriculture.pdf"
            },
            {
                text: "G.O.Ms.No.52",
                url: `${GOS_PDF_URL}9952_Marketing.pdf`,
                downloadUrl: "Downloads/9952_Marketing.pdf"
            },
            {
                text: "G.O.Ms.No.53",
                url: `${GOS_PDF_URL}GOMs_53_Cooperative.pdf`,
                downloadUrl: "Downloads/GOMs_53_Cooperative.pdf"
            },
            {
                text: "G.O.Ms.No.54",
                url: `${GOS_PDF_URL}9954_Horticulture.pdf`,
                downloadUrl: "Downloads/9954_Horticulture.pdf"
            },
            {
                text: "G.O.Ms.No.55",
                url: `${GOS_PDF_URL}9955_Sericulture.pdf`,
                downloadUrl: "Downloads/9955_Sericulture.pdf"
            },
            {
                text: "G.O.Ms.No.56",
                url: `${GOS_PDF_URL}9956_Animal%20Husb.pdf`,
                downloadUrl: "Downloads/9956_Animal%20Husb.pdf"
            },
            {
                text: "G.O.Ms.No.57",
                url: `${GOS_PDF_URL}9957_Fisheries.pdf`,
                downloadUrl: "Downloads/9957_Fisheries.pdf"
            },
            {
                text: "G.O.Ms.No.58",
                url: `${GOS_PDF_URL}9958_CAF_CS.pdf`,
                downloadUrl: "Downloads/9958_CAF_CS.pdf"
            },
            {
                text: "G.O.Ms.No.59",
                url: `${GOS_PDF_URL}9959_BCW_Dept.pdf`,
                downloadUrl: "Downloads/9959_BCW_Dept.pdf"
            },
            {
                text: "G.O.Ms.No.60",
                url: `${GOS_PDF_URL}9960_SCW_Dept.pdf`,
                downloadUrl: "Downloads/9960_SCW_Dept.pdf"
            },
            {
                text: "G.O.Ms.No.61",
                url: `${GOS_PDF_URL}9961_TWD.pdf`,
                downloadUrl: "Downloads/9961_TWD.pdf"
            },
            {
                text: "G.O.Ms.No.62",
                url: `${GOS_PDF_URL}9962_S_Edn.pdf`,
                downloadUrl: "Downloads/9962_S_Edn.pdf"
            },
            {
                text: "G.O.Ms.No.63",
                url: `${GOS_PDF_URL}9963_Intermediate.pdf`,
                downloadUrl: "Downloads/9963_Intermediate.pdf"
            },
            {
                text: "G.O.Ms.No.64",
                url: `${GOS_PDF_URL}GO_MS_64_T_A_Dept.pdf`,
                downloadUrl: "Downloads/GO_MS_64_T_A_Dept.pdf"
            },
            {
                text: "G.O.Ms.No.65",
                url: `${GOS_PDF_URL}9965_I_PR.pdf`,
                downloadUrl: "Downloads/9965_I_PR.pdf"
            },
            {
                text: "G.O.Ms.No.66",
                url: `${GOS_PDF_URL}9966_SEB.pdf`,
                downloadUrl: "Downloads/9966_SEB.pdf"
            },
            {
                text: "G.O.Ms.No.67",
                url: `${GOS_PDF_URL}9967_Public_Health.pdf`,
                downloadUrl: "Downloads/9967_Public_Health.pdf"
            },
            {
                text: "G.O.Ms.No.68",
                url: `${GOS_PDF_URL}9968_IPM.pdf`,
                downloadUrl: "Downloads/9968_IPM.pdf"
            },
            {
                text: "G.O.Ms.No.69",
                url: `${GOS_PDF_URL}9969_Drugs_Control.pdf`,
                downloadUrl: "Downloads/9969_Drugs_Control.pdf"
            },
            {
                text: "G.O.Ms.No.70",
                url: `${GOS_PDF_URL}9970_DGP_Home.pdf`,
                downloadUrl: "Downloads/9970_DGP_Home.pdf"
            },
            {
                text: "G.O.Ms.No.71",
                url: `${GOS_PDF_URL}9971_Fire_Service.pdf`,
                downloadUrl: "Downloads/9971_Fire_Service.pdf"
            },
            {
                text: "G.O.Ms.No.72",
                url: `${GOS_PDF_URL}9972_ENC_WRD.pdf`,
                downloadUrl: "Downloads/9972_ENC_WRD.pdf"
            },
            {
                text: "G.O.Ms.No.73",
                url: `${GOS_PDF_URL}9973_Ground_Water.pdf`,
                downloadUrl: "Downloads/9973_Ground_Water.pdf"
            },
            {
                text: "G.O.Ms.No.74",
                url: `${GOS_PDF_URL}9974_I_C_Export.pdf`,
                downloadUrl: "Downloads/9974_I_C_Export.pdf"
            },
            {
                text: "G.O.Ms.No.75",
                url: `${GOS_PDF_URL}9975_Hndlooms_Mod.pdf`,
                downloadUrl: "Downloads/9975_Hndlooms_Mod.pdf"
            },
            {
                text: "G.O.Ms.No.77",
                url: `${GOS_PDF_URL}9977_CCLA.pdf`,
                downloadUrl: "Downloads/9977_CCLA.pdf"
            },
            {
                text: "G.O.Ms.No.78",
                url: `${GOS_PDF_URL}9978_Survey.pdf`,
                downloadUrl: "Downloads/9978_Survey.pdf"
            },
            {
                text: "G.O.Ms.No.79",
                url: `${GOS_PDF_URL}9979_Prob_Excise.pdf`,
                downloadUrl: "Downloads/9979_Prob_Excise.pdf"
            },
            {
                text: "G.O.Ms.No.80",
                url: `${GOS_PDF_URL}9980_Registration.pdf`,
                downloadUrl: "Downloads/9980_Registration.pdf"
            },
            {
                text: "G.O.Ms.No.82",
                url: `${GOS_PDF_URL}9982_Endown.pdf`,
                downloadUrl: "Downloads/9982_Endown.pdf"
            },
            {
                text: "G.O.Ms.No.83",
                url: `${GOS_PDF_URL}9983_Planning.pdf`,
                downloadUrl: "Downloads/9983_Planning.pdf"
            },
            {
                text: "G.O.Ms.No.84",
                url: `${GOS_PDF_URL}9984_Panchayat_Raj.pdf`,
                downloadUrl: "Downloads/9984_Panchayat_Raj.pdf"
            },
            {
                text: "G.O.Ms.No.85",
                url: `${GOS_PDF_URL}9985_ENC_RWS.pdf`,
                downloadUrl: "Downloads/9985_ENC_RWS.pdf"
            },
            {
                text: "G.O.Ms.No.86",
                url: `${GOS_PDF_URL}9986_ENC_PR.pdf`,
                downloadUrl: "Downloads/9986_ENC_PR.pdf"
            },
            {
                text: "G.O.Ms.No.87",
                url: `${GOS_PDF_URL}9987_ENC_R_B.pdf`,
                downloadUrl: "Downloads/9987_ENC_R_B.pdf"
            },
            {
                text: "G.O.Ms.No.88",
                url: `${GOS_PDF_URL}9988_Transport.pdf`,
                downloadUrl: "Downloads/9988_Transport.pdf"
            },
            {
                text: "G.O.Ms.No.89",
                url: `${GOS_PDF_URL}9989_WCD.pdf`,
                downloadUrl: "Downloads/9989_WCD.pdf"
            },
            {
                text: "G.O.Ms.No.90",
                url: `${GOS_PDF_URL}9990_MAUD.pdf`,
                downloadUrl: "Downloads/9990_MAUD.pdf"
            },
            {
                text: "G.O.Ms.No.124",
                url: `${GOS_PDF_URL}AR_posts_provisional_allocation_to_districts.pdf`,
                downloadUrl: "Downloads/AR_posts_provisional_allocation_to_districts.pdf"
            },
            {
                text: "G.O.Ms.No.126",
                url: `${GOS_PDF_URL}GO_126.pdf`,
                downloadUrl: "Downloads/GO_126.pdf"
            },
            {
                text: "Revenue Department (Commercial Taxes-I)",
                url: `${GOS_PDF_URL}CTDeptEndt.pdf`,
                downloadUrl: "Downloads/CTDeptEndt.pdf"
            }
        ],
        image: false
    },
    {
        header: "CPS",
        links: [
            {
                text: "G.O.Ms.No.31", url: `${GOS_PDF_URL}GO_MS_31_Districts_Restructuring_Procedural_Guidelines.pdf`,
                downloadUrl: 'Downloads/GO_MS_31_Districts_Restructuring_Procedural_Guidelines.pdf'
            },

        ],
        image: false
    },
    {
        header: "BUDGET RELATED",
        links: [
            {
                text: "G.O.Ms.No.46", url: `${GOS_PDF_URL}46_OBJECT_HEADS.pdf`,
                downloadUrl: 'Downloads/46_OBJECT_HEADS.pdf'
            },
            {
                text: "G.O. MS. No.: 69", url: `${GOS_PDF_URL}69_OBJECT_HEADS.pdf`,
                downloadUrl: 'Downloads/69_OBJECT_HEADS.pdf'
            },

        ],
        image: false
    },
    {
        header: "Bill Submission",
        links: [
            {
                text: "G.O.RT.No. 1512",
                url: `${GOS_PDF_URL}schedule_for_bill_submission.PDF`,
                downloadUrl: "Downloads/schedule_for_bill_submission.PDF"
            },
        ],
        image: false
    },
    {
        header: "GO80",
        links: [
            {
                text: "G.O.Ms.No.80",
                url: `${GOS_PDF_URL}Decentralization.pdf`,
                downloadUrl: "Downloads/Decentralization.pdf"
            },
        ],
        image: false
    },
    {
        header: "Contract Employee Regularisation",
        links: [
            {
                text: "User Manual for Workflow for Contract Employees Application",
                url: `${GOS_PDF_URL}User_Manual_for_Work_Flow_for_Contract_Employees_Application.pdf`,
                downloadUrl: "Downloads/User_Manual_for_Work_Flow_for_Contract_Employees_Application.pdf"
            },
            {
                text: "User Manual for Contract Employee Regularization",
                url: `${GOS_PDF_URL}User_Manual_for_Contract_Employee_Regularization.pdf`,
                downloadUrl: "Downloads/User_Manual_for_Contract_Employee_Regularization.pdf"
            },
        ],
        image: false
    },
    {
        header: "CPS",
        links: [
            {
                text: 'G.O.Ms.No.196',
                url: `${GOS_PDF_URL}2012FIN_MS196.PDF`,
                downloadUrl: "Downloads/2012FIN_MS196.PDF"
            },
            {
                text: 'G.O.Ms.No.145',
                url: `${GOS_PDF_URL}2019FIN_MS145.PDF`,
                downloadUrl: "Downloads/2019FIN_MS145.PDF"
            },
            {
                text: 'New Pension System Circular',
                url: `${GOS_PDF_URL}5594_INSTS_ON_GO_336.PDF`,
                downloadUrl: "Downloads/5594_INSTS_ON_GO_336.PDF"
            },
            {
                text: 'G.O.Ms.No.97',
                url: `${GOS_PDF_URL}07052014FIN_MS97.PDF`,
                downloadUrl: "Downloads/07052014FIN_MS97.PDF"
            },
            {
                text: 'G.O.Ms.No.47',
                url: `${GOS_PDF_URL}20042018FIN_MS47.PDF`,
                downloadUrl: "Downloads/20042018FIN_MS47.PDF"
            },
            {
                text: 'National Pension System Circular',
                url: `${GOS_PDF_URL}Family_Pension_without_PRAN.pdf`,
                downloadUrl: "Downloads/Family_Pension_without_PRAN.pdf"
            },
            {
                text: 'G.O.Ms.No.112',
                url: `${GOS_PDF_URL}GO_112_CPS.PDF`,
                downloadUrl: "Downloads/GO_112_CPS.PDF"
            },
            {
                text: 'G.O.Ms.No.131',
                url: `${GOS_PDF_URL}GO_131CPS.PDF`,
                downloadUrl: "Downloads/GO_131CPS.PDF"
            },
            {
                text: 'G.O.Ms.No.22 CSS REFUND',
                url: `${GOS_PDF_URL}GO_MS_22_CSS_REFUND.PDF`,
                downloadUrl: "Downloads/GO_MS_22_CSS_REFUND.PDF"
            },
            {
                text: 'G.O.Ms.No.22 PAYMENT OF CSS ARREARS',
                url: `${GOS_PDF_URL}GO_MS_22_PAYMENT_OF_CSS_ARREARS.PDF`,
                downloadUrl: "Downloads/GO_MS_22_PAYMENT_OF_CSS_ARREARS.PDF"
            },
            {
                text: 'G.O.Ms.No.54',
                url: `${GOS_PDF_URL}GO_MS_54_ERRATA.PDF`,
                downloadUrl: "Downloads/GO_MS_54_ERRATA.PDF"
            },
            {
                text: 'G.O.Ms.No.62',
                url: `${GOS_PDF_URL}GO_MS_62_CPS_EXIT_AND_WITHDRAWL_GUIDELINES.PDF`,
                downloadUrl: "Downloads/GO_MS_62_CPS_EXIT_AND_WITHDRAWL_GUIDELINES.PDF"
            },
            {
                text: 'G.O.Ms.No.107',
                url: `${GOS_PDF_URL}GO_MS_107_DCRG_TO_CPS_EMP.PDF`,
                downloadUrl: "Downloads/GO_MS_107_DCRG_TO_CPS_EMP.PDF"
            },
            {
                text: 'G.O.Ms.No.112 (Foreign Service)',
                url: `${GOS_PDF_URL}GO_MS_112_CPS_FOR_FOREIGN_SERVICE.PDF`,
                downloadUrl: "Downloads/GO_MS_112_CPS_FOR_FOREIGN_SERVICE.PDF"
            },
            {
                text: 'G.O.Ms.No.121',
                url: `${GOS_PDF_URL}GO_MS_121_INVALID%20FAMILY%20PENSION.PDF`,
                downloadUrl: "Downloads/GO_MS_121_INVALID%20FAMILY%20PENSION.PDF"
            },
            {
                text: 'G.O.Ms.No.142',
                url: `${GOS_PDF_URL}GO_MS_142_INTEREST_ON_LEGACY_AMOUNT.PDF`,
                downloadUrl: "Downloads/GO_MS_142_INTEREST_ON_LEGACY_AMOUNT.PDF"
            },
            {
                text: 'G.O.Ms.No.178',
                url: `${GOS_PDF_URL}GO_MS_178_%20QUALIFYING_SERVICE.PDF`,
                downloadUrl: "Downloads/GO_MS_178_%20QUALIFYING_SERVICE.PDF"
            },
            {
                text: 'G.O.Ms.No.196 (Contributory Pension Scheme)',
                url: `${GOS_PDF_URL}GO_MS_196_UPLOADING_OF_CONTRIBUTIONS.PDF`,
                downloadUrl: "Downloads/GO_MS_196_UPLOADING_OF_CONTRIBUTIONS.PDF"
            },
            {
                text: 'G.O.Ms.No.226',
                url: `${GOS_PDF_URL}GO_MS_226_INTEREST_ON_CONTRIBUTIONS.PDF`,
                downloadUrl: "Downloads/GO_MS_226_INTEREST_ON_CONTRIBUTIONS.PDF"
            },
            {
                text: 'G.O.Ms.No.250',
                url: `${GOS_PDF_URL}GO_MS_250_UPLOADING_OF_AIS_CONTRIBUTIONS.PDF`,
                downloadUrl: "Downloads/GO_MS_250_UPLOADING_OF_AIS_CONTRIBUTIONS.PDF"
            },
            {
                text: 'G.O.Ms.No.336',
                url: `${GOS_PDF_URL}GO_MS_336_REFUND_OF_CPS_TO_GPF.PDF`,
                downloadUrl: "Downloads/GO_MS_336_REFUND_OF_CPS_TO_GPF.PDF"
            },
            {
                text: 'G.O.Ms.No.509',
                url: `${GOS_PDF_URL}GO_MS_509_CPS_FOR_AIS.PDF`,
                downloadUrl: "Downloads/GO_MS_509_CPS_FOR_AIS.PDF"
            },
            {
                text: 'G.O.Ms.No.653',
                url: `${GOS_PDF_URL}GO_MS_IMPL_OF_CPS_IN_AP.pdf`,
                downloadUrl: "Downloads/GO_MS_IMPL_OF_CPS_IN_AP.pdf"
            },
            {
                text: 'G.O.Ms.No.22',
                url: `${GOS_PDF_URL}GO22_CPS.PDF`,
                downloadUrl: "Downloads/GO22_CPS.PDF"
            },
            {
                text: 'G.O.Ms.No.62',
                url: `${GOS_PDF_URL}GO62_CPS_Exit.PDF`,
                downloadUrl: "Downloads/GO62_CPS_Exit.PDF"
            },
            {
                text: 'G.O.Ms.No.107',
                url: `${GOS_PDF_URL}GO107_CPS_FP.PDF`,
                downloadUrl: "Downloads/GO107_CPS_FP.PDF"
            },
            {
                text: 'G.O.Ms.No.121',
                url: `${GOS_PDF_URL}GO121_CPS_FP_IP.PDF`,
                downloadUrl: "Downloads/GO121_CPS_FP_IP.PDF"
            },
            {
                text: 'G.O.Ms.No.336',
                url: `${GOS_PDF_URL}GO336_CPS.PDF`,
                downloadUrl: "Downloads/GO336_CPS.PDF"
            },
            {
                text: 'G.O.Ms.No.47 (Gratuity)',
                url: `${GOS_PDF_URL}gratuity_FP_MS47.pdf`,
                downloadUrl: "Downloads/gratuity_FP_MS47.pdf"
            },
            {
                text: 'NPS Family Pension Instructions',
                url: `${GOS_PDF_URL}NPS_Family_Pension_Instructions.pdf`,
                downloadUrl: "Downloads/NPS_Family_Pension_Instructions.pdf"
            },
        ],
        image: false
    },



];
export const getBudgetPdfFileName = (fileName) => `budget-files/${fileName}`
export const getHrPayrollPdfFileName = (fileName) => `payroll/${fileName}`
export const getHrmsPdfFileName = (fileName) => `hrms/${fileName}`
export const getGpfPdfFileName = (fileName) => `gpf/${fileName}`
export const getPensionPdfFileName = (fileName) => `pension/${fileName}`
export const getVehiclesPdfFileName = (fileName) => `vehicle/${fileName}`
export const budgetPdfs = [
    {
        title: "Budget 2026-27",
        items: [
            {
                title: "Online submission of Budget Estimates 2026-27",
                pdf: `${GOS_BUDGET_URL_UPDATED}BE202627.pdf`,
                desc: "Online submission of Budget Estimates",
                isNew: true,
                // downloadUrl: `BE202627.pdf`
                downloadUrl: getBudgetPdfFileName(`BE202627.pdf`)

            },
        ],
        isNew: true,

    },
    {
        title: "Budget 2025-26",
        items: [
            {
                title: "Review of expenditure 2025-26",
                pdf: `${GOS_PDF_BUDGET_URL}U_O_Note_No_3032951_Budget_I_2025_Dated_20_11_2025.pdf`,
                desc: "Review of expenditure and Discussion on Preparation of Revised Estimates(RE) 2025-26",
                downloadUrl: getBudgetPdfFileName(`U_O_Note_No_3032951_Budget_I_2025_Dated_20_11_2025.pdf`)
            },
            {
                title: "Online submission of Budget Estimates 2025-26",
                pdf: `${GOS_PDF_URL3}2025FIN_MS3.pdf`,
                desc: "Online submission of Budget Estimates",
                downloadUrl: `2025FIN_MS3.pdf`

            },
        ],
    },

    {
        title: "Budget 2024-25",
        items: [
            {
                title: "Online submission of Budget Estimates",
                pdf: `${GOS_PDF_URL2}Budget2425Submission.pdf`,
                isNew: false,
                downloadUrl: `Budget2425Submission.pdf`

            },
            {
                title: "Meeting with the Departments of Secretariat and HoDs ",
                pdf: `${GOS_PDF_URL2}Budget2425MeetingSchedule.pdf`,
                isNew: false,
                downloadUrl: `Budget2425MeetingSchedule.pdf`

            },
        ],
    },

    {
        title: "Budget 2024-25 (VOA)",
        items: [
            {
                title: "Guidelines for Uploading budget estimates for 2024-25",
                pdf: `${GOS_PDF_URL2}GOMS126_BE_202425_Final.pdf`,
                isNew: false,
                downloadUrl: `GOMS126_BE_202425_Final.pdf`

            },
            {
                title: "Comprehensive Instructions",
                pdf: `${GOS_PDF_BUDGET_URL}}BudgetEstimates2024_25ComprehensiveInstructions.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName(`BudgetEstimates2024_25ComprehensiveInstructions.pdf`)

            },
            {
                title: "Pre Budget Meeting Presentation",
                pdf: `${GOS_PDF_BUDGET_URL}}BudgetPresentation2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('BudgetPresentation2024_25.pdf')
            },
            {
                title: "Training Session Budget 2024-25",
                pdf: `${GOS_PDF_BUDGET_URL}}Training_Preparation_BE24_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Training_Preparation_BE24_25.pdf')
            },
            {
                title: "Finance Minister's Budget Speech",
                pdf: `${GOS_PDF_BUDGET_URL}}DOLR_2286918_BG_2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('DOLR_2286918_BG_2024_25.pdf')
            },
            {
                title: "Further Extension of time",

                pdf: `${GOS_PDF_BUDGET_URL}}Further_Extend_time_2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Further_Extend_time_2024_25.pdf')
            },
            {
                title: "Meeting with Finance (Budget I) Department",
                pdf: `${GOS_PDF_BUDGET_URL}}DOLetterNO2301889_2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('DOLetterNO2301889_2024_25.pdf')
            },
            {
                title: "Meetings with Secretariat Departments & HODs",
                pdf: `${GOS_PDF_BUDGET_URL}}Postponed_Schedule_Budget_2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Postponed_Schedule_Budget_2024_25.pdf')
            },
            {
                title: "Review of Budget proposals",
                pdf: `${GOS_PDF_BUDGET_URL}}Revised_Schedule_Budget_2024_25.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Revised_Schedule_Budget_2024_25.pdf')
            },
        ],
    },

    {
        title: "Budget 2023-24",
        items: [
            {
                title: "Budget Estimates 2023-24",
                pdf: `${GOS_PDF_BUDGET_URL}}Budget_202324.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Budget_202324.pdf')
            },
            {
                title: "Preliminary Meeting",
                pdf: `${GOS_PDF_BUDGET_URL}}Budget_meeting_30112022.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Budget_meeting_30112022.pdf')

            },
            {
                title: "Pre Budget Meeting Presentation",
                pdf: `${GOS_PDF_BUDGET_URL}}AP_BUDGET_PRESENTATION_2023_24_v1-2.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('AP_BUDGET_PRESENTATION_2023_24_v1-2.pdf')
            },
            {
                title: "Budget 2023-24 User Manual",
                pdf: `${GOS_PDF_BUDGET_URL}}UserManual_01122022.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('UserManual_01122022.pdf')
            },
            {
                title: "Meetings with Secretariat Departments & HoDs",
                pdf: `${GOS_PDF_BUDGET_URL}}Budget_2023_24_new.pdf`,
                isNew: false,
                downloadUrl: getBudgetPdfFileName('Budget_2023_24_new.pdf')

            },
        ],
    },
];
export const usermanualshrpayroll = [
    {
        title: "User Guide for Workflow Configuration to Update Office, Post Sanctions & Employees Data",
        pdf: `${UserManualsforHrPayroll}PSE_HR_Manager_WF.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`PSE_HR_Manager_WF.pdf`)


    },
    {
        title: "User Guide for Workflow Configuration to Adding New Employee",
        pdf: `${UserManualsforHrPayroll}}PSE_WF_ADD_NEW_EMPLOYEE.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`PSE_WF_ADD_NEW_EMPLOYEE.pdf`)

    },
    {
        title: "User Guide for Workflow Configuration to Submit Monthly Attendance & Paybill",
        pdf: `${UserManualsforHrPayroll}}PSE_WF_ATTENDANCE.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('PSE_WF_ATTENDANCE.pdf')
    },
    {
        title: "User Guide for Workflow Configuration to Generate Sanction Order",
        pdf: `${UserManualsforHrPayroll}}PSE_WF_SANCTION_ORDER.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('PSE_WF_SANCTION_ORDER.pdf')
    },
    {
        title: "User Guide for Update Office, Post Sanctions & Employees Data",
        pdf: `${UserManualsforHrPayroll}}UM_OFFICES_POSTS_UPDATE_EMP.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('UM_OFFICES_POSTS_UPDATE_EMP.pdf')
    },
    {
        title: "User Guide for Adding New Employee",

        pdf: `${UserManualsforHrPayroll}}UM_PSE_ADD_EMPLOYEE.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('UM_PSE_ADD_EMPLOYEE.pdf')
    },
    {
        title: "User Guide for Submit Monthly Attendance & Paybill",
        pdf: `${UserManualsforHrPayroll}}DOLetterNO2301889_2024_25.pdf`,
        isNew: false,
        downloadUrl: getBudgetPdfFileName('DOLetterNO2301889_2024_25.pdf')
    },
    {
        title: "User Guide for Generate Sanction Order",
        pdf: `${UserManualsforHrPayroll}}Postponed_Schedule_Budget_2024_25.pdf`,
        isNew: false,
        downloadUrl: getBudgetPdfFileName('Postponed_Schedule_Budget_2024_25.pdf')
    },

]

export const usermanualsEsr = [
    {
        title: "G.O.MS.No. 57 Dated: 20-07-2026",
        pdf: `${UserManualsforHrPayroll}}GO Ms 57 e SR pdf.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('GO Ms 57 e SR pdf.pdf')
    },
    {
        title: "User Manual",
        pdf: `${UserManualsforHrPayroll}}ESR2.0_Usermanual_Part_Nidhi Version.2.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName('ESR2.0_Usermanual_Part_Nidhi Version.2.pdf')
    },
]
export const usermanualsgpf = [
    {
        title: "Insruction on GPF Final Withdrawl Authorizations ",
        pdf: `${UserManualsforGPF}Insruction on GPF Final Withdrawl Authorizations.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`Insruction on GPF Final Withdrawl Authorizations.pdf`)
    },
    {
        title: "G.O Ms.No.9 Dated:14-02-2026, FINANCE (HR-III-PENSION & GPF) DEPARTMENT, Andhra Pradesh General Provident Fund (APGPF) – Provision of Streamlined Online Services on NIDHI platform ",
        pdf: `${UserManualsforGPF}2026FIN_40329_MS9_E 2.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`2026FIN_40329_MS9_E 2.pdf`)
    },
    {
        title: "GPF SUBSCRIPTION INCREASE/DECREASE",
        pdf: `${UserManualsforGPF}GPF_Subscription.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`GPF_Subscription.pdf`)
    },
    {
        title: "GPF TEMPORARY ADVANCE",
        pdf: `${UserManualsforGPF}GPF_Temporary_Advance_updated.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`GPF_Temporary_Advance_updated.pdf`)
    },
    {
        title: "GPF PART FINAL WITHDRAWL",
        pdf: `${UserManualsforGPF}GPF_Part_Final_Widhraw_updated.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`GPF_Part_Final_Widhraw_updated.pdf`)
    },
    {
        title: "User Manual for GPF Final Bill Generation for Manually Authorized Cases",
        pdf: `${UserManualsforGPF}GPF Final Bill Generation-Manually Authorized.pdf`,
        isNew: false,
        downloadUrl: getGpfPdfFileName(`GPF Final Bill Generation-Manually Authorized.pdf`)
    },

]
export const usermanualspension = [
    {
        title: "G.O.Ms.No.10 Dated: 14.02.2026, FINANCE (HR-III-PENSION & GPF) DEPARTMENT, Retirement Benefits Processing System (RBPS) – Streamlined & integrated online delivery of retirement benefits on NIDHI",
        pdf: `${UserManualsforPension}/GO_MS_NO-10.pdf`,
        isNew: false,
        downloadUrl: getPensionPdfFileName(`GO_MS_NO-10.pdf`)
    },
    {
        title: "Fixation of cut-off date for submission of physical pension proposals",
        pdf: `${UserManualsforPension}/2026FIN_RT1438_E.pdf`,
        isNew: false,
        downloadUrl: getPensionPdfFileName(`2026FIN_RT1438_E.pdf`)
    },
    {
        title: "PENSION USER MANUAL",
        pdf: `${UserManualsforPension}/Pension_employee_manual.pdf`,
        isNew: false,
        downloadUrl: getPensionPdfFileName(`Pension_employee_manual.pdf`)
    }
];
export const usermanualscontract = [
    {
        title: "CONTRACT CIRCULAR MEMO",
        pdf: `${UserManualsforHrPayroll}Contract_circular_memo.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`Contract_circular_memo.pdf`)
    },
    {
        title: "CONTRACT USER MANUAL",
        pdf: `${UserManualsforHrPayroll}SOP_For_HR_and_Payroll_Contract_Emp.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`SOP_For_HR_and_Payroll_Contract_Emp.pdf`)
    },
];
export const usermanualsHRM = [
    {
        title: "Cir Memo 3194187, 26 03 2026_implementation of eHRM",
        pdf: `${UserManualsforHrPayroll}Cir Memo 3194187, 26 03 2026_implementation of eHRM.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`Cir Memo 3194187, 26 03 2026_implementation of eHRM.pdf`)
    },
    {
        title: "UO Note 3194187, 01 04 2026_eHRM_Meeting with HoDs",
        pdf: `${UserManualsforHrPayroll}UO Note 3194187, 01 04 2026_eHRM_Meeting with HoDs.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`UO Note 3194187, 01 04 2026_eHRM_Meeting with HoDs.pdf`)
    },
    {
        title: "Workflow Configuration Usermanual",
        pdf: `${UserManualsforHrPayroll}Updated Workflow Configuation E- HRM Manual (Multiple Makers).pdf .pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`Updated Workflow Configuation E- HRM Manual (Multiple Makers).pdf .pdf`)
    },
    {
        title: "Service Rule Master Data (GSM / SSM)",
        pdf: `${UserManualsforHrPayroll}User Manual for Service Rule Master Data.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual for Service Rule Master Data.pdf`)
    },
    {
        title: "User Manual for Cadre Master Data (GSM / SSM)",
        pdf: `${UserManualsforHrPayroll}User Manual for Cadre Master Data.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual for Cadre Master Data.pdf`)
    },

    {
        title: "User Manual for CCM (HOD)",
        pdf: `${UserManualsforHrPayroll}User Manual CCM (HOD).pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual CCM (HOD).pdf`)
    },
    {
        title: "User Manual for eHRM Grievance",
        pdf: `${UserManualsforHrPayroll}User Manual for e HRM Grievance.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual for e HRM Grievance.pdf`)
    },
    {
        title: "User Manual for Cadre Distribution (CDM)",
        pdf: `${UserManualsforHrPayroll}User Manual for Cadre Distribution Module.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual for Cadre Distribution Module.pdf`)
    },
    {
        title: "User Manual for Personnel Distribution Module (PDM)",
        pdf: `${UserManualsforHrPayroll}User_Manual_for_Personnel_Distribution_Module.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User_Manual_for_Personnel_Distribution_Module.pdf`)
    },
];
export const usermanualsvehicles = [
    {
        title: "Cir.Memo.No.2728014/FIN01-HR0VM(RGHV)/1/2025-2, Dt:17.04.2026 – Public Services – Hired Vehicles – Continuation of Hired Vehicles for Official Use from the Financial Year 2026–27 onwards – Instructions to Send Proposals through Online Application – Regarding.",
        pdf: `${UserManualsforVehicles}CirMemo-2728014-FIN01-HR0VM(RGHV)-1-2025-2 dt 17-4-2026 TFR HR V.pdf`,
        isNew: false,
        downloadUrl: getVehiclesPdfFileName(`CirMemo-2728014-FIN01-HR0VM(RGHV)-1-2025-2 dt 17-4-2026 TFR HR V.pdf`)
    },
    {
        title: "Workflow Guide",
        pdf: `${UserManualsforVehicles}}Workflow_Guide_Vehicle_Management_v5.pdf`,
        isNew: false,
        downloadUrl: getVehiclesPdfFileName(`Workflow_Guide_Vehicle_Management_v5.pdf`)

    },

]

export const usermanualsEL = [

    {
        title: "User Manual – Encashment of Earned Leave (EL).",
        pdf: `${UserManualsforHrPayroll}User Manual for Encashment of Earned Leave.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User Manual for Encashment of Earned Leave.pdf`)
    },
]
export const usermanualsPO = [


    {
        title: "Organisation of Local Cadres Module (OLM)",
        pdf: `${UserManualsforHrPayroll}OLM User Manual v2.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`OLM User Manual v2.pdf`),
        videoLink: "-"

    },
]
export const usermanualsEVigil = [
    {
        title: "Government Orders (G.O) & Memos",
        downloadUrl: getHrPayrollPdfFileName("Schedule on Review of Disciplinar Cases - CS Memo dt 06 07 2026.pdf"),
        videoLink: null
    },
    {
        title: "User manual to Chief Vigilance Officers (CVOs)/Vigilance Officers (VOs) and NODC to Update Legacy Cases and Add New Cases",
        downloadUrl: getHrPayrollPdfFileName("User Manual for e-Vigilance (1).pdf"),
        videoLink: null
    },
    {
        title: "Video Guide (Step by Step Video Guide) for CVO/VOs and NODCs",
        downloadUrl: null,
        videoLink: "https://youtu.be/wnPcwoLNi2g?si=Cw8TWp9FYBYrymBm"
    }
];
export const usermanualsCER = [

    {
        title: "Circular Memo on Act 30.",
        pdf: `${UserManualsforHrPayroll}circular Memo on Act 30.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`circular Memo on Act 30.pdf`)
    },
    {
        title: "Circular Memo 13122023.",
        pdf: `${UserManualsforHrPayroll}circular Memo 13122023.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`circular Memo 13122023.pdf`)
    },
    {
        title: "User Manual for Contract Employee Application.",
        pdf: `${UserManualsforHrPayroll}User_Manual_for_Work_Flow_for_Contract_Employees_Application.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User_Manual_for_Work_Flow_for_Contract_Employees_Application.pdf`)
    },
    {
        title: "User Manual for Contract Employee Regularization.",
        pdf: `${UserManualsforHrPayroll}User_Manual_for_Contract_Employee_Regularization.pdf`,
        isNew: false,
        downloadUrl: getHrPayrollPdfFileName(`User_Manual_for_Contract_Employee_Regularization.pdf`)
    },
]
export const usermanualscdm = [



]

// compute clock skew from axios response headers
export const getClockSkew = (headers) => {
    const dateHeader = headers?.['date'];
    if (!dateHeader) return 0;
    const serverMs = new Date(dateHeader).getTime();
    if (isNaN(serverMs)) return 0;
    return Date.now() - serverMs;
};

// Timer function
export const startOtpTimer = (challengeExpiresAt, setRemainingTime, clockSkewMs = 0) => {
    const expiryMs = challengeExpiresAt * 1000;

    const updateTimer = () => {
        const serverNowMs = Date.now() - clockSkewMs;  // normalize to server time
        const remaining = Math.max(
            Math.floor((expiryMs - serverNowMs) / 1000),
            0
        );
        setRemainingTime(remaining);
    };

    updateTimer();

    const interval = setInterval(() => {
        updateTimer();
        if ((Date.now() - clockSkewMs) >= expiryMs) {
            clearInterval(interval);
        }
    }, 1000);

    return () => clearInterval(interval);
};

// export const startOtpTimer = (challengeExpiresAt, setRemainingTime) => {

//     const updateTimer = () => {

//         const remaining = Math.max(
//             Math.floor((challengeExpiresAt * 1000 - Date.now()) / 1000),
//             0
//         );

//         setRemainingTime(remaining);
//     };

//     updateTimer();

//     const interval = setInterval(() => {

//         updateTimer();

//         if (Date.now() >= challengeExpiresAt * 1000) {
//             clearInterval(interval);
//         }

//     }, 1000);

//     return () => clearInterval(interval);
// };

export const formatCountdown = (totalSeconds = 0) => {
    const safeSeconds = Math.max(Number(totalSeconds) || 0, 0);

    const minutes = Math.floor(safeSeconds / 60);
    const seconds = safeSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export default async function Sweetalert(text, icon) {
    return Swal.fire({ text: text, icon: icon, confirmButtonColor: '#3085d6', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false, confirmButtonText: "Ok" });
}

export const isEmpty = (v) => !v || v.trim() === "";

export const popover = (
    <Popover className="ps-character" id="popover-basic">
        {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
        <Popover.Body>
            <div className="">
                <p>Password must contain</p>
                <ul>
                    <li>Capital alphabet 1</li>
                    <li>Small alphabet 1</li>
                    <li>Special character 1</li>
                    <li>Number 1</li>
                    <li>Minimum length 8</li>
                    <li>Maximum length 16</li>
                </ul>
            </div>
        </Popover.Body>
    </Popover>
);

export const preventCopyPaste = (e) => {
    e.preventDefault();
};
